export const getElementIndexById = (elementId, scribe) =>
  scribe.elements.findIndex(element => element.id === elementId);
